import React from 'react'

const DropIcon = () => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6629 9.5C14.7798 9.5 14.8733 9.45276 14.9434 9.35827L15.6448 8.64961C15.7149 8.57874 15.75 8.48425 15.75 8.36614C15.75 8.24803 15.7149 8.14173 15.6448 8.04724L8.28054 0.641732C8.21041 0.547244 8.11689 0.5 8 0.5C7.88311 0.5 7.78959 0.547244 7.71946 0.641732L0.355204 8.04724C0.285068 8.14173 0.25 8.24803 0.25 8.36614C0.25 8.48425 0.285068 8.57874 0.355204 8.64961L1.05656 9.35827C1.1267 9.45276 1.22021 9.5 1.3371 9.5C1.454 9.5 1.5592 9.45276 1.65271 9.35827L8 2.94488L14.3473 9.35827C14.4408 9.45276 14.546 9.5 14.6629 9.5Z"
      fill="#2C2C2C"
    />
  </svg>
)

export { DropIcon }
